module.exports = __webpack_public_path__ + "img/kjfwms.2b3f41e3.png";